import { PageWrapper } from '@/shared'

export const EmptyList = () => (
    <PageWrapper>
        <div>Список пуст</div>
    </PageWrapper>
)
